<div class="warp-approval" *ngIf="details$() as details">
    <div class="approval" *ngIf="details && !isapproved$() && details.isApproved!=true" >
        <h1>שלום ל - {{details?.firstName}} {{details?.lastName}}</h1>
        <h2>{{details?.subject}}</h2>
        <p>{{details?.content}}</p>
        <button (click)="approval()">אישור</button>
    </div>
    <div class="approval" *ngIf="details && !isapproved$() && details.isApproved" >
        <h1>שלום ל - {{details?.firstName}} {{details?.lastName}}</h1>
       <div>אישרת כבר על קבלת תזכורת זו </div>
       <div>תודה</div>
    </div>
    <div *ngIf="isapproved$()">
        תודה רבה !
        אישורך נשמר במערכת
    </div>
</div>
<!-- <div class="warp">
    <div  class="card" [style.height]="'20vh'">
      111111111111111
    </div>
    <div  class="card" [style.height]="'30vh'">
        22222222222222222
     </div>
     <div  class="card" [style.height]="'30vh'">
        3333333333333333333
     </div>
     <div  class="card" [style.height]="'20vh'">
        444444444444444444444444
     </div>
     <div  class="card" [style.height]="'40vh'">
        555555555555555555
     </div>

      <div  class="card" [style.height]="'37vh'">
       dsvgdfsgsdfgfdsghdsfhdf
    </div>
    <div  class="card" [style.height]="'20vh'">
        dsvgdfsgsdfgfdsghdsfhdf
     </div>
</div> -->